/*eslint-disable */
/**
 * This function calculated which of the given time slots to select by default.
 * All passed-in and returned times are integers - minutes from midnight.
 *
 * @param Array slots Array of time slots available, in minutes from midnight. Sorted in ascending order. Example: [0, 60, 180, 240].
 * @param Object options Hash of optional options:
 *       > Integer preferredTime Time to select if it is available.
 *       > String timeOfDay Time of day of preferred time. One of "MORNING", "AFTERNOON", "EVENING". Is overridden by preferredTime.
 * @return Integer (-1 if no time slots provided)
 */
define(function (require) {
    var _ = require('underscore'),
        timeUtil = require('./time');

    return function(slots, options) {
        options = options || {};

        var hasPreference,
            preferredTime = options.preferredTime,
            timeFrom = options.timeFrom,
            timeTo = options.timeTo,
            selectedTime = -1;

        if ((null == preferredTime || isNaN(preferredTime)) && timeFrom) {
            preferredTime = timeUtil.timeToMinutes(timeFrom.substr(0,2)+':'+timeFrom.substr(2,4));
        }

        hasPreference = !isNaN(preferredTime);

        _.any(slots, function (time, position) {
            if ((!hasPreference && 0 === position) || (hasPreference && preferredTime <= time)) {
                selectedTime = time;
                return true;
            }

        });

        if (-1 === selectedTime && hasPreference && slots.length > 0) {
            // No time match was found. Set the last time as active.
            selectedTime = slots[ slots.length - 1 ];
        }

        return selectedTime;
    };
});
